<template>
  <svg
    :class="svgClasses"
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="viewbox"
    :width="resolvedWidth"
    :height="resolvedHeight"
    :style="svgStyle"
    aria-hidden="true"
    focusable="false"
  >
    <path :d="path" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    type: {
      type: String,
      default: 'mdi',
    },
    path: {
      type: String,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 24,
    },
    width: {
      type: [Number, String],
      default: null,
    },
    height: {
      type: [Number, String],
      default: null,
    },
    viewbox: {
      type: String,
      default: '0 0 24 24',
    },
    color: {
      type: String,
      default: '',
    },
    rotate: {
      type: [Number, String],
      default: '0deg',
    },
    flip: {
      type: String,
      default: null,
    },
    left: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    resolvedWidth() {
      return this.width ?? this.size;
    },
    resolvedHeight() {
      return this.height ?? this.size;
    },
    svgClasses() {
      return {
        'svg-icon': true,
        'svg-icon--left': this.left,
      };
    },
    svgStyle() {
      const transforms = [];

      if (this.flip === 'horizontal' || this.flip === 'both') {
        transforms.push('scaleX(-1)');
      }
      if (this.flip === 'vertical' || this.flip === 'both') {
        transforms.push('scaleY(-1)');
      }
      if (this.rotate && this.rotate !== '0deg' && this.rotate !== 0) {
        const rotation = typeof this.rotate === 'number' ? `${this.rotate}deg` : this.rotate;
        transforms.push(`rotate(${rotation})`);
      }

      return {
        color: this.color || undefined,
        transform: transforms.length ? transforms.join(' ') : undefined,
      };
    },
  },
};
</script>

<style scoped>
.svg-icon {
  display: inline-block;
  vertical-align: middle;
}

.svg-icon--left {
  margin-right: 4px;
}
</style>
